const dev = {
  api: 'http://localhost:7100',
  website: 'http://localhost:3100',
  shield: 'http://localhost:7500',
  explore: 'http://localhost:3400',
  partner_logos_bucket:
    'https://mulberry-partner-logos-develop.s3.amazonaws.com',
  d2cExtensionID: 'ijojokgfipkfcofiljgialclhlicgpim',
  d2cPublicToken: 'token',
  sentryEnabled: false,
}

const develop = {
  api: 'https://partner-develop.getmulberry.com',
  website: 'https://app-develop.getmulberry.com',
  shield: 'https://shield-develop.getmulberry.com',
  explore: 'https://explore-develop.getmulberry.com',
  partner_logos_bucket:
    'https://mulberry-partner-logos-develop.s3.amazonaws.com',
  pricing_api: 'http://pricing-develop.getmulberry.com',
  d2cExtensionID: 'doheogeolmnlejjfpdfldnnicofckndc',
  d2cPublicToken: '3fF9h9dFGRN3PfkxOMoTorCRbjM',
  sentryEnabled: true,
}

const staging = {
  api: 'https://partner-staging.getmulberry.com',
  website: 'https://app-staging.getmulberry.com',
  shield: 'https://shield-staging.getmulberry.com',
  explore: 'https://explore-staging.getmulberry.com',
  partner_logos_bucket:
    'https://mulberry-partner-logos-staging.s3.amazonaws.com',
  d2cExtensionID: 'doheogeolmnlejjfpdfldnnicofckndc',
  d2cPublicToken: 'B7Vmoe37-JZuHli66m20wlhZlO4',
  sentryEnabled: true,
}

const production = {
  api: 'https://partner.getmulberry.com',
  website: 'https://app.getmulberry.com',
  shield: 'https://shield.getmulberry.com',
  explore: 'https://explore.getmulberry.com',
  partner_logos_bucket: 'https://mulberry-partner-logos.s3.amazonaws.com',
  d2cExtensionID: 'doheogeolmnlejjfpdfldnnicofckndc',
  d2cPublicToken: 'c3d30L0C8yr0dnxMtDP2H4KIN6o',
  sentryEnabled: true,
}

const k8spoc = {
  api: 'https://partner-k8s-poc.getmulberry.com',
  website: 'https://k8s-poc.getmulberry.com',
  explore: 'https://explore-poc.getmulberry.com',
  shield: 'https://shield-k8s-poc.getmulberry.com',
  d2cExtensionID: 'doheogeolmnlejjfpdfldnnicofckndc',
  d2cPublicToken: 'PQAHo_UI-dMyYXelmTs5ziyXw7U',
  sentryEnabled: true,
}

export const Locations = {
  LOGIN: '/login',
}

export const exploreLocations = {
  LOGIN: '/login',
  MY_PLANS: '/my-plans',
  SELF_SERVE_ONBOARDING: '/complete-onboarding',
}

let configuration

if (
  process.env.REACT_APP_STAGE === 'staging' ||
  process.env.REACT_APP_STAGE === 'master'
) {
  // using CI branch for REACT_APP_STAGE which is "master" for staging
  configuration = staging
} else if (process.env.REACT_APP_STAGE === 'production') {
  configuration = production
} else if (process.env.REACT_APP_STAGE === 'poc') {
  configuration = k8spoc
} else if (process.env.REACT_APP_STAGE) {
  configuration = develop
} else {
  configuration = dev
}

export default {
  ...configuration,
  stripeToken: process.env.STRIPE_PUB_KEY,
  mulberryPubToken: process.env.MULBERRY_PUB_TOKEN,
  sentryDsn:
    'https://b94c3818df66424aa3e8a94fa23746c5@o153706.ingest.sentry.io/4505250310455297',
}
